var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"menu-button"}},[_c('icon',{attrs:{"size":"sm","colour":"blue","icon":_vm.icon},nativeOn:{"click":function($event){return _vm.toggleDrawer($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }